import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { confirmedAndWaitlist } from "../lib/padel";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const GIORNI = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const MonthCalendar = ({ matches, selected, onSelect }) => {
  const today = new Date();
  const [cursor, setCursor] = useState(new Date(today.getFullYear(), today.getMonth(), 1));

  const byDate = {};
  matches.forEach((m) => { (byDate[m.date] = byDate[m.date] || []).push(m); });

  const year = cursor.getFullYear();
  const month = cursor.getMonth();
  const firstDay = new Date(year, month, 1);
  const startOffset = (firstDay.getDay() + 6) % 7; // Monday-first
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(year, month, d));

  const todayStr = ymd(today);

  return (
    <div className="rounded-2xl bg-[#121b2d] border border-[#1e2c4a] p-4" data-testid="month-calendar">
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => setCursor(new Date(year, month - 1, 1))}
          data-testid="cal-prev"
          className="w-9 h-9 rounded-full bg-slate-900/60 border border-slate-700 flex items-center justify-center text-slate-300 hover:border-[#ccff00]/40"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <h3 className="font-heading font-extrabold text-lg text-white" data-testid="cal-title">{MESI[month]} {year}</h3>
        <button
          onClick={() => setCursor(new Date(year, month + 1, 1))}
          data-testid="cal-next"
          className="w-9 h-9 rounded-full bg-slate-900/60 border border-slate-700 flex items-center justify-center text-slate-300 hover:border-[#ccff00]/40"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      <div className="grid grid-cols-7 gap-1 mb-2">
        {GIORNI.map((g) => (
          <div key={g} className="text-center text-[11px] font-bold uppercase tracking-wider text-slate-500">{g}</div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1">
        {cells.map((date, i) => {
          if (!date) return <div key={i} />;
          const ds = ymd(date);
          const dayMatches = byDate[ds] || [];
          const has = dayMatches.length > 0;
          const isToday = ds === todayStr;
          const isSel = ds === selected;
          return (
            <button
              key={i}
              disabled={!has}
              onClick={() => onSelect(isSel ? null : ds)}
              data-testid={`cal-day-${ds}`}
              className={`aspect-square rounded-xl flex flex-col items-center justify-center text-sm relative transition-colors
                ${isSel ? "bg-[#ccff00] text-[#090d16] font-bold"
                  : has ? "bg-slate-900/60 text-slate-100 hover:bg-slate-800 border border-[#ccff00]/30"
                  : "text-slate-600"}
                ${isToday && !isSel ? "ring-1 ring-[#00e5ff]/60" : ""}`}
            >
              <span>{date.getDate()}</span>
              {has && (
                <span className={`mt-0.5 text-[9px] font-bold ${isSel ? "text-[#090d16]" : "text-[#ccff00]"}`}>
                  ● {dayMatches.length}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const matchesOnDate = (matches, dateStr) => matches.filter((m) => m.date === dateStr);
export const todayString = () => ymd(new Date());
